var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{clip-path:url(#c);}.d,.e{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.e{stroke-linejoin:round;}.f{fill:#cee1ff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-865 -7480)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-1996 3537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.06 0.053)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-845.533-7457.022s8.109-3.771,10.922,5.038c3.048-.469,10.784-1.172,9.11,7.3s-6.564,12.559-9.11,12.325-20.582-9.223-15.726-21.143"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-845.9-7455l5.727,6.907s-4.789.8-7.871-4.655C-846.7-7454.054-845.9-7455-845.9-7455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-859.653-7467.456l9.452,11.377,2.094-1.755-9.226-11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-848.826-7462.239s3.263-.395,2.392-4.849,2.143-3.617,2.713-3.215a15.627,15.627,0,0,1,1.865,3.215"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-840.17-7468.54s1.968-3.4-.975-5.943-.113-3.509,1.358-3.226,5.32,3.565,6.283,4.924"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-842.112-7460.871c-.812-3.421,5.247-8.479,8.687-10s1.045-5.138,3.265-5.312,2.786,1.741,1.654,4.223c-1,1.35,2.638-.037,2.856,2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-839.434-7461.691c2.917-2.612,11.451-6.749,16.284-5.355s2.133,5.85-.3,5.629-8.094.295-7.432,7.138"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-824.367-7458.953s5.831,2.962,1.085,11.453"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M27.967,61.022c.262.248,5.31,5,10.111,5.851a2.539,2.539,0,0,0,.435.039,2.4,2.4,0,0,0,2.021-1.094,13.069,13.069,0,0,0,1.08-2.12,17.792,17.792,0,0,0,1.238-4.907,15.476,15.476,0,0,1-1.074,1.846,6.521,6.521,0,0,1-8.02,2.166,21.809,21.809,0,0,1-9.524-8.228,8.054,8.054,0,0,0,.928,2.8,16.819,16.819,0,0,0,2.807,3.646",
    transform: "translate(-872.275 -7502.075)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality7);
export default __webpack_public_path__ + "static/media/speciality7.fd245ce7d3a0b532e20cd66e1b25fd78.svg";
export { ForwardRef as ReactComponent };